/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Whats_New_ImprovedInputs */

const en_whats_new_improved = /** @type {(inputs: Whats_New_ImprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Improved`)
};

const de_whats_new_improved = /** @type {(inputs: Whats_New_ImprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbessert`)
};

/**
* | output |
* | --- |
* | "Improved" |
*
* @param {Whats_New_ImprovedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const whats_new_improved = /** @type {((inputs?: Whats_New_ImprovedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Whats_New_ImprovedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_whats_new_improved(inputs)
	return en_whats_new_improved(inputs)
});